import { render, staticRenderFns } from "./TabelaProdutosComprar.vue?vue&type=template&id=304be953&scoped=true"
import script from "./TabelaProdutosComprar.vue?vue&type=script&lang=js"
export * from "./TabelaProdutosComprar.vue?vue&type=script&lang=js"
import style0 from "./TabelaProdutosComprar.vue?vue&type=style&index=0&id=304be953&prod&scoped=true&lang=css"
import style1 from "./TabelaProdutosComprar.vue?vue&type=style&index=1&id=304be953&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304be953",
  null
  
)

export default component.exports